var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_72_4433)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48333 13.9667C3.90269 13.9667 1 11.064 1 7.48333C1 3.90269 3.90269 1 7.48333 1C11.064 1 13.9667 3.90269 13.9667 7.48333C13.9667 11.064 11.064 13.9667 7.48333 13.9667ZM0 7.48333C0 3.3504 3.3504 0 7.48333 0C11.6163 0 14.9667 3.3504 14.9667 7.48333C14.9667 11.6163 11.6163 14.9667 7.48333 14.9667C3.3504 14.9667 0 11.6163 0 7.48333ZM8.53995 9.93182L8.64648 2.09091H7.19762L7.30415 9.93182H8.53995ZM7.24556 12.8029C7.43377 12.9911 7.65927 13.0852 7.92205 13.0852C8.09961 13.0852 8.25941 13.0426 8.40146 12.9574C8.54705 12.8686 8.66246 12.7514 8.74769 12.6058C8.83647 12.4602 8.88086 12.3004 8.88086 12.1264C8.88086 11.8636 8.78675 11.6381 8.59854 11.4499C8.41033 11.2617 8.18484 11.1676 7.92205 11.1676C7.65927 11.1676 7.43377 11.2617 7.24556 11.4499C7.05735 11.6381 6.96325 11.8636 6.96325 12.1264C6.96325 12.3892 7.05735 12.6147 7.24556 12.8029Z",
    fill: "#1E1E1E",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_72_4433",
    x: -4,
    y: -4,
    width: 22.9668,
    height: 22.9666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_72_4433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_72_4433",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.40a20c0aa099822ea09f5fa091bb46d3.svg";
export { ForwardRef as ReactComponent };